var _path, _path2, _path3, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusDocument(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "url(#paint0_linear_1829_55026)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H17.01H17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13H15C13.8954 13 13 13.8954 13 15V27C13 28.1046 13.8954 29 15 29H25C26.1046 29 27 28.1046 27 27V15C27 13.8954 26.1046 13 25 13H23M17 13C17 14.1046 17.8954 15 19 15H21C22.1046 15 23 14.1046 23 13M17 13C17 11.8954 17.8954 11 19 11C19 11 19.8954 11 21 11C22.1046 11 23 11.8954 23 13M20 20H23M20 24H23M17 20H17.01M17 24H17.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1829_55026",
    x1: 5.74936,
    y1: 1.71842,
    x2: 29.1145,
    y2: 28.3324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDocument);
export default __webpack_public_path__ + "static/media/status-document.8cb737ea.svg";
export { ForwardRef as ReactComponent };